module.exports = __webpack_public_path__ + "img/ditan_xc2.0c4ebb64.jpg";